import { distinctUntilChanged } from 'rxjs';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChild, DestroyRef, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { type AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';

@Component({
    selector: 'medsurf-design-form-control-input-text',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './text.input.form-control.design.html',
    styleUrls: ['./text.input.form-control.design.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    standalone: false
})
export class TextInputFormControlDesign implements OnInit, OnChanges {
  @Input() formField = true;
  @Input({ required: true }) control!: AbstractControl;
  @Input() inputType = 'text';
  @Input() inputClass: FlatModels.TextDesignModels.TextDesignClass = FlatModels.TextDesignModels.TextDesignClass.DEFAULT;
  @Input() placeholder = "";
  @Input() label?: string;
  @Input() inputGroup = false;
  @Input() disabled = false;
  @Input() autofocus = false;
  @Output() keyup = new EventEmitter<KeyboardEvent>();
  @Output() valueChange = new EventEmitter<Event>();
  
  @ViewChild('inputElement', {static: false}) inputElement: ElementRef<HTMLInputElement>;
  @ContentChild('content') content?: ElementRef;
  
  name?: string;

  constructor(private cd: ChangeDetectorRef, private destroyRef: DestroyRef) {
  }

  ngOnInit() {
    const formGroup = this.control.parent;
    this.name = formGroup ? Object.keys(formGroup.controls).find(name => this.control === formGroup.get(name)) : undefined;

    if (this.name === undefined) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.form_control_name_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatDesign.TextInputFormControlDesign.ngOnInit"
      );
    }
    
    this.control?.statusChanges.pipe(takeUntilDestroyed(this.destroyRef), distinctUntilChanged()).subscribe(() => {
      this.cd.markForCheck();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']?.currentValue) {
      this.control?.disable();
    } else {
      this.control?.enable();
    }
  }
}
